import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CampaignStatusEnum } from '../../public-api';
import { AbstractService } from '../commons/abstract.service';
import { SearchParams } from '../commons/abstract.types';
import { AudienceSelection, AudienceSummary } from '../models/audience-summary.model';
import { Campaign } from '../models/campaign.model';

@Injectable({ providedIn: 'root' })
export class CampaignService extends AbstractService<Campaign> {

  getURLBase(): string {
    return '/campaign';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(campaign: Campaign): void {
    delete campaign?._id;
  }

  preUpdate(campaign: Campaign): void {
  }

  updateTags(campaign: Campaign): Observable<Campaign> {
    return super.put(`/tags/${campaign._id}`, campaign);
  }

  updateActive(campaign: Campaign): Observable<Campaign> {
    return super.put(`/${campaign._id}/activation`, null);
  }

  updateInactive(campaign: Campaign): Observable<Campaign> {
    return super.put(`/${campaign._id}/inactivation`, null);
  }

  audienceSummary(selection: AudienceSelection): Observable<AudienceSummary> {
    return super.post('/audience/summary', selection);
  }

  getDataAnalytics(params?: Partial<SearchParams>): Observable<unknown> {
    return super.getWithParams('/fetch/analytics', params ?? {});
  }

  getDataAnalyticsDash(query: any): Observable<unknown> {
    const dayStart = this.toCalendarDay(query.dateStart);
    const dayEnd = this.toCalendarDay(query.dateEnd);
    return super.get(`/fetch/analytics/dasboard?dateStart=${dayStart}&dateEnd=${dayEnd}&channel=${query.channel}`);
  }

  private toCalendarDay(value: string | Date): string {
    if (!(value instanceof Date) || isNaN(value.getTime())) {
      return `${value ?? ''}`;
    }

    const month = `${value.getMonth() + 1}`.padStart(2, '0');
    const day = `${value.getDate()}`.padStart(2, '0');
    return `${value.getFullYear()}-${month}-${day}`;
  }

  updateByStatus(id: string, status: CampaignStatusEnum): Observable<void> {
    return super.put(`/update/status/${id}`, { status });
  }

  restartOrContinueCampaign(idCampaign: string): Observable<void> {
    return super.get(`/restart/continue/${idCampaign}`);
  }

  cloneCampaign(idCampaign: string): Observable<Campaign> {
    return super.put(`/clone/campaign/${idCampaign}`, { idCampaign });
  }

  getCountTotalCampaing(idCompany: string): Observable<number> {
    return super.get(`/total/${idCompany}`);
  }

}
